module.exports = __webpack_public_path__ + "img/clear-filter.dbe816b5.svg";